import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './translations';

// 将现有的translations对象转换为i18next格式
const resources = {
  en: {
    translation: {
      ...translations.en,
      // 添加Pricing页面所需的键
      pricing: {
        ...translations.en.pricing,
        title: 'Simple Pricing',
        subtitle: 'Choose the plan that best fits your needs. All plans include a 14-day free trial.',
        monthly: 'Monthly',
        yearly: 'Yearly',
        save: 'Save 16%',
        mostPopular: 'Most Popular',
        free: 'Free',
        mo: 'mo',
        yr: 'yr',
        processing: 'Processing...',
        getStarted: 'Get Started',
        subscribe: 'Subscribe'
      },
      plans: {
        'free': {
          name: 'Free',
          description: 'For individuals trying out',
          features: [
            'Basic features',
            'Up to 10 sheets',
            'Up to 500 rows of data',
            'Community support',
            'Advanced features',
            'Unlimited sheets',
            'Priority support'
          ]
        },
        'pro': {
          name: 'Pro',
          description: 'For individuals and small teams',
          features: [
            'Basic features',
            'Unlimited sheets',
            'Unlimited rows',
            'Advanced features',
            'Data export',
            '5 team members',
            'Priority support'
          ]
        },
        'business': {
          name: 'Business',
          description: 'For larger teams and enterprises',
          features: [
            'All Pro features',
            'Unlimited team members',
            'Advanced analytics',
            'API access',
            'Dedicated account manager',
            'Custom feature development',
            'Service level agreement'
          ]
        },
        'pro-yearly': {
          name: 'Pro (Yearly)',
          description: 'For individuals and small teams',
          features: [
            'Basic features',
            'Unlimited sheets',
            'Unlimited rows',
            'Advanced features',
            'Data export',
            '5 team members',
            'Priority support'
          ]
        },
        'business-yearly': {
          name: 'Business (Yearly)',
          description: 'For larger teams and enterprises',
          features: [
            'All Pro features',
            'Unlimited team members',
            'Advanced analytics',
            'API access',
            'Dedicated account manager',
            'Custom feature development',
            'Service level agreement'
          ]
        }
      }
    }
  },
  zh: {
    translation: {
      ...translations.zh,
      // 添加Pricing页面所需的键
      pricing: {
        ...translations.zh.pricing,
        title: '简单定价',
        subtitle: '选择最适合您的方案。所有方案都包含14天免费试用。',
        monthly: '月付',
        yearly: '年付',
        save: '省16%',
        mostPopular: '最受欢迎',
        free: '免费',
        mo: '月',
        yr: '年',
        processing: '处理中...',
        getStarted: '开始使用',
        subscribe: '订阅'
      },
      plans: {
        'free': {
          name: '免费版',
          description: '适合个人用户试用',
          features: [
            '基础功能使用',
            '最多10个表格',
            '最多500行数据',
            '社区支持',
            '高级功能',
            '无限表格',
            '优先支持'
          ]
        },
        'pro': {
          name: '专业版',
          description: '适合个人用户和小型团队',
          features: [
            '基础功能使用',
            '无限表格',
            '无限行数据',
            '高级功能',
            '数据导出',
            '5个团队成员',
            '优先支持'
          ]
        },
        'business': {
          name: '企业版',
          description: '适合大型团队和企业',
          features: [
            '专业版所有功能',
            '无限团队成员',
            '高级分析功能',
            'API访问',
            '专属客户经理',
            '定制功能开发',
            '服务级别协议'
          ]
        },
        'pro-yearly': {
          name: '专业版(年度)',
          description: '适合个人用户和小型团队',
          features: [
            '基础功能使用',
            '无限表格',
            '无限行数据',
            '高级功能',
            '数据导出',
            '5个团队成员',
            '优先支持'
          ]
        },
        'business-yearly': {
          name: '企业版(年度)',
          description: '适合大型团队和企业',
          features: [
            '专业版所有功能',
            '无限团队成员',
            '高级分析功能',
            'API访问',
            '专属客户经理',
            '定制功能开发',
            '服务级别协议'
          ]
        }
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zh', // 设置默认语言为中文
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // 不转义HTML
    },
    returnObjects: true // 默认允许返回对象
  });

export default i18n; 